import React, { Component } from 'react';
import { Button, Row, Col, Alert, InputGroup } from 'reactstrap';

import { TroubleTicketForm } from './TroubleTicketForm';
import { TroubleTicketTableDefault } from './TroubleTicketTableDefault';
import { LoadingModal } from './LoadingModal';

import { FetchData } from './utils/DataFetch';
import { GetCookie, Timeout } from './utils/Common';

import AddIcon from '../images/add.png';

export class TroubleTicket extends Component {
  static displayName = TroubleTicket.name;

  constructor(props) {
    super(props);
    this.state = {
      troubleTicketList: [],
      loading: false,
      fetchingData: false,
      modal: false,
      alert: {
        color: 'info',
        message: '',
        isOpen: false,
      },
      model: {
        EventType: 'insert',
        TroubleTicketId: null,
        TroubleTicketNumber: null,
        JobId: null,
        JobNum: null,
        UserId: null,
        ClaimantId: null,
        ClientId: null,
        RepId: null,
        ProvId: null,
        IntId: null,
        Description: '',
        WorkFlowId: '',
        TroubleTicketStatus: '',
        Priority: '',
        Category: '',
        Source: '',
        AssignedToUserId: null,
        DueDate: null,
        ResolutionNotes: '',
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        // Display fields
        ClientName: '',
        ClientAbbrv: '',
        ClmFirstName: '',
        ClmLastName: '',
        RepFirstName: '',
        RepLastName: '',
        IntFirstName: '',
        IntLastName: '',
        ProvOfficeName: '',
        AssignedToFirstName: '',
        AssignedToLastName: '',
      },
      searchModel: {
        TroubleTicketId: null,
        JobId: null,
        ClaimantId: null,
        ClientId: null,
        IntId: null,
        ProvId: null,
        RepId: null,
        Status: '',
        Priority: '',
        Category: '',
        AssignedToUserId: null,
      },
    };
    this.user = JSON.parse(GetCookie('user'));

    this.setModal = this.setModal.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.resetFields = this.resetFields.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    this.populateTroubleTicketData();
  }

  setModal() {
    this.setState({ modal: !this.state.modal });
  }

  resetFields() {
    this.setState({
      model: {
        EventType: 'insert',
        TroubleTicketId: null,
        TroubleTicketNumber: null,
        JobId: null,
        JobNum: null,
        UserId: null,
        ClaimantId: null,
        ClientId: null,
        RepId: null,
        ProvId: null,
        IntId: null,
        Description: '',
        WorkFlowId: '',
        TroubleTicketStatus: 'Open',
        Priority: '',
        Category: '',
        Source: '',
        AssignedToUserId: null,
        DueDate: null,
        ResolutionNotes: '',
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        ClientName: '',
        ClientAbbrv: '',
        ClmFirstName: '',
        ClmLastName: '',
        RepFirstName: '',
        RepLastName: '',
        IntFirstName: '',
        IntLastName: '',
        ProvOfficeName: '',
        AssignedToFirstName: '',
        AssignedToLastName: '',
      },
    });

    this.setModal();
  }

  handleDoubleClick(ticketData) {
    const d = ticketData.data;
    this.setState({
      model: {
        EventType: 'update',
        TroubleTicketId: d.troubleTicketId,
        TroubleTicketNumber: d.troubleTicketNumber,
        JobId: d.jobId,
        JobNum: d.jobNum,
        UserId: d.userId,
        ClaimantId: d.claimantId,
        ClientId: d.clientId,
        RepId: d.repId,
        ProvId: d.provId,
        IntId: d.intId,
        Description: d.description,
        WorkFlowId: d.workFlowId,
        TroubleTicketStatus: d.troubleTicketStatus,
        Priority: d.priority,
        Category: d.category,
        Source: d.source,
        AssignedToUserId: d.assignedToUserId,
        DueDate: d.dueDate,
        ResolutionNotes: d.resolutionNotes,
        CreateDateTime: d.createDateTime,
        CreateByUserId: d.createByUserId,
        UpdateByUserId: d.updateByUserId,
        UpdateDateTime: d.updateDateTime,
        IsDeletedFlg: d.isDeletedFlg,
        ClientName: d.clientName,
        ClientAbbrv: d.clientAbbrv,
        ClmFirstName: d.clmFirstName,
        ClmLastName: d.clmLastName,
        RepFirstName: d.repFirstName,
        RepLastName: d.repLastName,
        IntFirstName: d.intFirstName,
        IntLastName: d.intLastName,
        ProvOfficeName: d.provOfficeName,
        AssignedToFirstName: d.assignedToFirstName,
        AssignedToLastName: d.assignedToLastName,
      },
    });

    this.setModal();
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
        this.populateTroubleTicketData();
      },
    );
  }

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model }, () => {
      this.populateTroubleTicketData();
    });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.populateTroubleTicketData();
    }
  }

  async populateTroubleTicketData() {
    this.setState({ fetchingData: true });

    await FetchData(
      '/gettroubletickets',
      'POST',
      this.user.token,
      this.state.searchModel,
    ).then((data) => {
      this.setState({
        troubleTicketList: data,
        loading: false,
        fetchingData: false,
      });
    });
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      <TroubleTicketTableDefault
        troubleTickets={this.state.troubleTicketList}
        handleDoubleClick={this.handleDoubleClick}
      />
    );

    return (
      <div style={{ paddingTop: '12px', overflow: 'hidden' }}>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tableLabel">Trouble Tickets</h5>
        <Row>
          <Col>
            <InputGroup size="sm">
              <Button color="btn" onClick={this.resetFields} size="sm">
                <img
                  src={AddIcon}
                  style={{ width: '16px', height: '16px' }}
                  alt="Add"
                />{' '}
                New
              </Button>
              <select
                name="Status"
                className="form-control form-control-text"
                value={this.state.searchModel.Status}
                onChange={this.handleSearchChange}
                onKeyDown={this.handleKeyDown}
                style={{ maxWidth: '150px' }}
              >
                <option value="">All Statuses</option>
                <option value="Open">Open</option>
                <option value="In Progress">In Progress</option>
                <option value="Resolved">Resolved</option>
                <option value="Closed">Closed</option>
              </select>
              <select
                name="Priority"
                className="form-control form-control-text"
                value={this.state.searchModel.Priority}
                onChange={this.handleSearchChange}
                onKeyDown={this.handleKeyDown}
                style={{ maxWidth: '150px' }}
              >
                <option value="">All Priorities</option>
                <option value="Critical">Critical</option>
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
              <select
                name="Category"
                className="form-control form-control-text"
                value={this.state.searchModel.Category}
                onChange={this.handleSearchChange}
                onKeyDown={this.handleKeyDown}
                style={{ maxWidth: '180px' }}
              >
                <option value="">All Categories</option>
                <option value="Scheduling">Scheduling</option>
                <option value="Quality">Quality</option>
                <option value="Billing">Billing</option>
                <option value="Technical">Technical</option>
                <option value="Interpreter No-Show">Interpreter No-Show</option>
                <option value="Late Cancellation">Late Cancellation</option>
                <option value="Document Issue">Document Issue</option>
                <option value="Communication">Communication</option>
                <option value="Other">Other</option>
              </select>
              <Button
                color={this.state.searchModel.AssignedToUserId ? 'primary' : 'secondary'}
                size="sm"
                onClick={() => {
                  let searchModel = { ...this.state.searchModel };
                  searchModel.AssignedToUserId = searchModel.AssignedToUserId
                    ? null
                    : this.user.userid;
                  this.setState({ searchModel }, () =>
                    this.populateTroubleTicketData(),
                  );
                }}
                style={{ whiteSpace: 'nowrap' }}
              >
                Assigned To Me
              </Button>
            </InputGroup>
          </Col>
        </Row>
        <hr />

        <LoadingModal fetchingData={this.state.fetchingData} />

        {this.state.modal && (
          <TroubleTicketForm
            model={this.state.model}
            modal={this.state.modal}
            alert={this.state.alert}
            setModal={this.setModal}
            handleSaveEventSuccess={this.handleSaveEventSuccess}
            onSaveSuccess={() => this.populateTroubleTicketData()}
          />
        )}

        <div>{contents}</div>
      </div>
    );
  }
}
